import type { FaireProductEntity } from "../../entity_types/product";

export const p_pvqf2gg5tp: FaireProductEntity = {
  token: "p_pvqf2gg5tp",
  type: "product",
  name: "In A Good Place Forest - Customizable- Long Sleeve Tee",
  brandToken: "b_1bd10jxt4j",
  brandName: "MT Brand Apparel",
  imageUrl: "https://cdn.faire.com/fastly/d146c9131e790f905c6b6dc21662185adce063cd4b25cb027d0fadc065c04835.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0ba65354476f71c7893f6ef9211f252989b32738cbf0d415a0266f44eca6ffdf.jpeg",
    "https://cdn.faire.com/fastly/b89c0573b0bf51ff26b8939e97d9bcf15fcd6373019461c5791b966f7fa6c7db.jpeg",
    "https://cdn.faire.com/fastly/25b87fddb8b1b52ca29f0ca1ea50f8a03f0d25b490054fb3c5b18e8be6eb59e5.jpeg"
  ],
  priceDollars: 15,
  description: "Our long sleeve crew neck tee is a unisex fit.\nPerfect for outdoor & casual fun.\n\nOur In A Good Place graphic can be customized. We will replace Sunapee with your location or business name.\nSizing is available in X-Small though 3XL.\n\nDijon & Mustard colored tees are 80% cotton and manufactured by Port & Company.\nDeep Heather, Ash Gray and Heather Slate are a cotton/poly blend and manufactured by Bella Canvas.\nDeep Teal and Heather Emerald are a tri-blend of cotton, polyester and rayon. Manufactured by Bella Canvas.\n\nMT Brand Apparel prints, engraves, embroiders and ships from Stevensville, Montana.",
  tags: [],
  msrpDollars: 30,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:47.031Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
